import { findLastIndex } from 'lodash';

export const getNextAvailableProgramId = (programs: any) => {
    const lastCompletedProgramIndex = findLastIndex(programs, (program: any) => Boolean(program?.completed));

    return programs.length && programs[lastCompletedProgramIndex + 1]?.id;
};
